import { isPlatformServer } from "@angular/common";
import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Inject, Injectable, LOCALE_ID, NgModule, Optional, PLATFORM_ID } from "@angular/core";
import { REQUEST } from "@nguniversal/express-engine/tokens";
import { Observable, tap } from "rxjs";

@Injectable({
	providedIn: 'root'
})
export class HttpsRequestInterceptor implements HttpInterceptor {

	constructor(
        @Inject(PLATFORM_ID) private platformId: any,
		@Inject(LOCALE_ID) private locale,
        @Optional() @Inject(REQUEST) private request: any,
    ) { }

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (isPlatformServer(this.platformId)) {
            if(this.request.headers['x-forwarded-host']) {
                req = req.clone({ headers: req.headers.set('x-forwarded-host', this.request.headers['x-forwarded-host']) });
            } else if(this.request.headers['host']) {
                req = req.clone({ headers: req.headers.set('x-forwarded-host', this.request.headers['host']) });
            } else {
				console.log(`No forwarded host. Origin: ${this.request.headers['Origin'] || this.request.headers['origin']} Host: ${this.request.headers['host'] || this.request.headers['Host']}`);
			}
		}
		if(this.locale) {
			req = req.clone({ headers: req.headers.set('Accept-Language', this.locale) });
		}
		return next.handle(req).pipe(tap((event: HttpEvent<any>) => {
			if (event instanceof HttpResponse) {
				return event;
			}
		}));
	}
};
@NgModule({
	providers: [
		{
			provide: HTTP_INTERCEPTORS,
			useClass: HttpsRequestInterceptor,
			multi: true
		}
	]
})
export class RestModule { }
